import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import { BatchCreationActions } from '../actions/BatchCreationActions';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  cashoutBatchList: { ...initialStateList },
  cashoutUploaded: false,
  uploadResponse: {
    id: '',
    totalRecords: 0,
    totalErrors: 0,
    errors: [],
  },
};

export const Batch = handleActions(
  {
    ...GridFilters,
    [BatchCreationActions.CASHOUT_CREATE_BATCH]: (state, actions) => {
      return { ...state, cashoutUploaded: true, uploadResponse: { ...actions.payload } };
    },
  },
  initialState
);

const getBatch = (state) => state.Batch;

export const getCashoutBatchList = (state, list) => {
  const batch = getBatch(state);
  return batch[list] || undefined;
};

export const getUploadResponse = createSelector(getBatch, (state) => {
  return state.uploadResponse;
});

export const getCashoutUploaded = createSelector(getBatch, (state) => {
  return state.cashoutUploaded;
});
